"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGES = void 0;
var LANGUAGES;
(function (LANGUAGES) {
    LANGUAGES["ar"] = "ar";
    LANGUAGES["ca"] = "ca";
    LANGUAGES["cs"] = "cs";
    LANGUAGES["de"] = "de";
    LANGUAGES["en"] = "en";
    LANGUAGES["es"] = "es";
    LANGUAGES["eu"] = "eu";
    LANGUAGES["fr"] = "fr";
    LANGUAGES["gl"] = "gl";
    LANGUAGES["it"] = "it";
    LANGUAGES["ko"] = "ko";
    LANGUAGES["ml"] = "ml";
    LANGUAGES["ms"] = "ms";
    LANGUAGES["nl"] = "nl";
    LANGUAGES["pa"] = "pa";
    LANGUAGES["pl"] = "pl";
    LANGUAGES["pt"] = "pt";
    LANGUAGES["ro"] = "ro";
    LANGUAGES["ta"] = "ta";
    LANGUAGES["te"] = "te";
    LANGUAGES["tl"] = "tl";
    LANGUAGES["th"] = "th";
    LANGUAGES["zh"] = "zh";
})(LANGUAGES = exports.LANGUAGES || (exports.LANGUAGES = {}));
//# sourceMappingURL=locale.js.map